import React from "react";
import { Box } from "../../../common";

const CustomerContracts = () => {
  return <Box height="70vh">Coming Soon</Box>;
};

export default CustomerContracts;
